module.exports = __webpack_public_path__ + "static/media/1whitepine2.3b169c63.jpg";